module Meevo.Plugins.AppointmentBook {
    class WorkTicketController {
        public url: any;
        public reportTitle: string = 'LABEL_RECEIPT_WORK_TICKET';
        public showReportLink: boolean = device.androidPhone() || device.iphone() || device.ipad();

        static $inject = [
            "$mdDialog", "meevo.components.modal.ModalService", "$translate", '$scope', 'locals', "$element"
        ];

        constructor(private $mdDialog,
            protected modalService: Meevo.Components.Modal.IModalService,
            private $translate: angular.translate.ITranslateService,
            protected $scope,
            protected locals: any,
            protected $element
        ) {
            this.url = locals.pdfUrl;
            this.reportTitle = locals.label;

            var reportLink = $element.find("#reportLink")
            if (reportLink) { 
                reportLink.on("click", () => this.cancel());
            }
        }

        cancel() {
            this.$mdDialog.hide();
        }

        onReportLoad() {
            $('#workTicketReportContent').attr('src', this.url);
        }
    }

    angular.module("ApptBookApp").controller("meevo.plugins.appointmentbook.WorkTicketController", WorkTicketController);
}